import {
  DialogTitle as MUIDialogTitle,
  DialogContent as MUIDialogContent,
  DialogActions as MUIDialogActions,
  styled
} from '@mui/material';

export const DialogContent = styled(MUIDialogContent)(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const DialogTitle = styled(MUIDialogTitle)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1)
}));

export const DialogActions = styled(MUIDialogActions)(({ theme }) => ({
  padding: theme.spacing(2)
}));
